import { UpdateConference } from 'domain/usecases/conference/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteUpdateConference implements UpdateConference {
  private readonly url: string;

  private readonly httpClient: HttpClient<UpdateConference.Model>;

  constructor(url: string, httClient: HttpClient<UpdateConference.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  update = async (
    params: UpdateConference.Params,
  ): Promise<UpdateConference.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{conferenceId}', `${params.conferenceId}`),
      body: params.body,
      method: 'patch',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
